namespace Areas.TimeEntry.Review {
    "user strict";
        
    export function viewTimesheetLink(cellElement, cellInfo) {
        const employeeId = cellInfo.data.employeeId;
        const weekEndingDate = moment(cellInfo.data.weekEndingDate).format("YYYY-MM-DD");
        const link = `<a href= '/Employee/Time/Index/${employeeId}?start=${weekEndingDate}'>View</a>`;

        cellElement.html(link);
    }

    export function onCellPrepared(e: any) {
        if (e.rowType !== "data") {
            return;
        }
        setLockedByBackground(e);
    }

    function setLockedByBackground(e) {
        var isApprovedDataCell = e.column.dataField === "supervisorApprovalBy";

        if (isApprovedDataCell) {
            if (e.data.supervisorApprovalBy == null) {
                e.cellElement.css("background-color", "yellow");
            }
        }
    }
}